import React from 'react';
import ImageComponent from 'atoms/Image';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';
import { ButtonComp, ButtonType, ContainedButton } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TENANT_IMAGE_BASE_URL } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { PROMOS_AND_REWARDS_CONSTANT } from 'organisms/PromosRewards/Constants/PromosRewardsConstant';
import { sanitizeContent } from 'organisms/CouponsLanding/utils/CouponUtils';
import { PLP_PAGE, PICK_UP, DELIVERY, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getAndCheck, getAndCheckIfOneTrue, isCateringDisposition } from 'common/utilities/utils';

export const PromosRewardsCard = props => {
  const {
    smallText,
    titleValue,
    imageName,
    item,
    tenantId,
    setConfirmationModal,
    setViewDetailsHandler,
    showMultiProductModal,
    dispositionType,
    addToOrderClickHandler,
    startOrderClickHandler,
    promosApplied,
    basketData,
    setViewCartHandler,
    setDispositionHandler,
    createSignInURL,
    page,
  } = props;

  const {
    ITEM_IN_CART,
    ONE_PROMO_APPLIED,
    DELIVERY_PROMOTION,
    PICKUP_PROMOTION,
    VIEW_MENU,
    START_ORDER,
    VIEW_PRODUCT,
    PROMO_ADD_TO_CART,
    VIEW_DETAILS,
    CHANGE_PICKUP,
    CHANGE_DELIVERY,
    VIEW_CART,
    GUEST_USER_SINGIN_TEXT,
    SIGNIN_TEXT,
    CHECK_BACK_AGAIN,
    THATS_ALL_FOR_NOW,
    CATERING_PROMO_ERROR,
    NO_IMAGE,
  } = TRANSLATE_MAPPING_KEY;
  const { SignInCard, Error_Yellow, GreenCheck, Applied_CouponIcon } = IMAGE_PATH;
  const { DEFAULT_IMAGE_PATH, PROMOS_CARD_IMAGE_PATH } = PROMOS_AND_REWARDS_CONSTANT;

  const itemsInCart = basketData?.foodLines?.length || 0;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { componentOptions: { web: { plp: { promosRewardsImage } = {} } = {} } = {} } = tenantReducer ?? {};
  const getText = itemVal => {
    if (itemVal?.isApplied && itemsInCart && itemVal?.itemDetails) {
      return translateWithI18Next(ITEM_IN_CART) + '.'; //point 3
    } else if (!itemVal?.isApplied && promosApplied) {
      return translateWithI18Next(ONE_PROMO_APPLIED); // point 8
    } else {
      // point 6,7
      return dispositionType === PICK_UP
        ? translateWithI18Next(DELIVERY_PROMOTION)
        : translateWithI18Next(PICKUP_PROMOTION);
    }
  };
  const getLink = itemVal => {
    if (itemVal?.isApplied && itemsInCart && itemVal?.itemDetails) {
      //point 3
      return (
        <div
          onClick={event => setViewCartHandler(props)}
          className='promos-tost-link'
          data-testid='change-deals-handler'
        >
          <u>{translateWithI18Next(VIEW_CART)}</u>
        </div>
      );
    } else if (!itemVal?.isApplied && promosApplied) {
      // point 8
      return '';
    } else {
      // point 6,7
      let _txt =
        dispositionType === PICK_UP ? translateWithI18Next(CHANGE_DELIVERY) : translateWithI18Next(CHANGE_PICKUP);
      let _disposition = dispositionType === PICK_UP ? DELIVERY : PICK_UP;
      return (
        <div
          onClick={event => setDispositionHandler(_disposition)}
          className='promos-tost-link'
          data-testid='change-deals-handler'
        >
          <u>{_txt}</u>
        </div>
      );
    }
  };

  /* Rendering discount button */
  const discountButton = () => {
    return (
      <React.Fragment>
        {item?.isApplied && (
          <>
            <div className={`promosButton-item ${getAndCheck(page === PLP_PAGE, 'plp-promosButton-item')}`}>
              <div
                className={`promos-checked-icon ${page === PLP_PAGE && 'plp-promos-checked-icon'}`}
                onClick={event => setConfirmationModal(props, event)}
                data-testid='greentick-button'
              >
                <ReactSVG
                  src={Applied_CouponIcon}
                  className={`promos-appled-icon ${getAndCheck(page === PLP_PAGE, 'plp-promos-appled-icon')}`}
                  alt=''
                />
              </div>
              <ContainedButton
                variant={item?.isApplied && !itemsInCart ? ButtonType.primary : ButtonType.tertiary}
                onClick={event => startOrderClickHandler(props, event)}
                data-testid='promos-and-rewards-image-text-button'
                aria-label={`${translateWithI18Next(VIEW_DETAILS)} ${titleValue}`}
              >
                {itemsInCart ? translateWithI18Next(VIEW_MENU) : translateWithI18Next(START_ORDER)}
              </ContainedButton>
            </div>
          </>
        )}
        {!item?.isApplied && (
          <>
            <div className={`promosButton-item ${getAndCheck(page === PLP_PAGE, 'plp-promosButton-item')}`}>
              <ContainedButton
                variant={ButtonType.secondary}
                onClick={event => addToOrderClickHandler(props, event)}
                data-testid='promos-and-rewards-image-text-button'
                aria-label={`${translateWithI18Next(VIEW_DETAILS)} ${titleValue}`}
              >
                {translateWithI18Next(PROMO_ADD_TO_CART)}
              </ContainedButton>
            </div>
          </>
        )}
      </React.Fragment>
    );
  };

  /* Rendering product Button */
  const productButton = () => {
    return (
      <React.Fragment>
        <div className={`promosButton-item ${getAndCheck(page === PLP_PAGE, 'plp-promosButton-item')}`}>
          <ContainedButton
            variant={ButtonType.secondary}
            onClick={event => showMultiProductModal(props, event)}
            disabled={item?.isApplied}
            data-testid='promos-and-rewards-image-text-button'
            aria-label={`${translateWithI18Next(VIEW_DETAILS)} ${titleValue}`}
          >
            {translateWithI18Next(VIEW_PRODUCT)}
          </ContainedButton>
        </div>
      </React.Fragment>
    );
  };

  /* Rendering DispositionConflict text */
  const dispositionConflict = () => {
    return (
      <React.Fragment>
        <div className={`promosButton-item ${page === PLP_PAGE && 'plp-toast-item'}`}>
          <div className={`promos-tost-container ${item?.isApplied && 'greenbg'}`}>
            <div className='promos-tost-icon '>
              {item?.isApplied && itemsInCart && item?.itemDetails && (
                <>
                  <ReactSVG src={GreenCheck} className='promos-store-image green-icon' alt='' />
                </>
              )}
              {!item?.isApplied && (
                <>
                  <ReactSVG
                    src={Error_Yellow}
                    className={`promos-store-image ${page === PLP_PAGE && 'plp-promos-store-image'}`}
                    alt=''
                  />
                </>
              )}
            </div>
            <div className='promos-tost-text-container'>
              <div className='promos-tost-text'>
                {isCateringDisposition(dispositionType) ? translateWithI18Next(CATERING_PROMO_ERROR) : getText(item)}
              </div>
              {isCateringDisposition(dispositionType) ? null : getLink(item)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  /* show promos button  */
  const getPromosButton = itemInfo => {
    if (getAndCheck(isCateringDisposition(dispositionType), !itemInfo?.employeePromotion)) {
      return dispositionConflict();
    }
    let itemParameter = itemInfo?.termsAndConditions[0]?.parameter;
    itemInfo?.termsAndConditions?.forEach(condtion => {
      if (getAndCheckIfOneTrue(condtion?.parameter?.includes(DELIVERY), condtion?.parameter?.includes(PICK_UP))) {
        itemParameter = condtion?.parameter;
      }
    });
    if (promosApplied && getAndCheck(!itemInfo?.isApplied, !itemInfo?.employeePromotion)) {
      //point 8
      return dispositionConflict();
    } else if (
      getAndCheckIfOneTrue(
        itemParameter?.includes(dispositionType),
        getAndCheck(!itemParameter?.includes(DELIVERY), !itemParameter?.includes(PICK_UP)),
      )
    ) {
      if (itemInfo?.itemDetails) {
        clearStorage();
        // point 2 and 3
        if (itemInfo?.isApplied) {
          return dispositionConflict();
        } else {
          return productButton();
        }
      }
      // point 2 and 4,5,9
      return discountButton();
    } else {
      // point 6,7
      return dispositionConflict();
    }
  };
  const clearStorage = () => {
    // clearing local storage if cart cleared on expiry for product based promos
    if (getAndCheck(!itemsInCart, localStorage.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER))) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER);
    }
  };
  const getImageComponent = () => (
    <>
      <ImageComponent
        srcFile={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${PROMOS_CARD_IMAGE_PATH}${imageName}`}
        alt={translateWithI18Next(NO_IMAGE)}
        defaultPath={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${DEFAULT_IMAGE_PATH}`}
        className='promosOnlyImage-background'
      />
      <div className={`promosCard-content promosFullImageCard-content ${getAndCheck(promosApplied, 'promos-applied')}`}>
        <div className='view-all-text fullImageText-item'>
          <div
            onClick={event => setViewDetailsHandler(props)}
            className='offersViewAll-link'
            data-testid='view-all-deals-handler'
          >
            <u>{translateWithI18Next(VIEW_DETAILS)}</u>
          </div>
        </div>
        {getPromosButton(item)}
      </div>
    </>
  );

  const getImageTextComponent = () => (
    <>
      <ImageComponent
        srcFile={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${PROMOS_CARD_IMAGE_PATH}${imageName}`}
        alt={translateWithI18Next(NO_IMAGE)}
        defaultPath={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${DEFAULT_IMAGE_PATH}`}
        className='promosImageText-background'
      />
      <div className='promosCard-content'>
        <div className='promosImageTextCard-title'>
          <span className='promosCard-ellipsis-text'>{sanitizeContent(titleValue)}</span>
        </div>
        <div className='promosCard-text'>
          <span className='promosCard-ellipsis-text'>{sanitizeContent(smallText)}</span>
        </div>
        <div className='view-all-text'>
          <div
            onClick={event => setViewDetailsHandler(props)}
            className='offersViewAll-link'
            data-testid='view-all-deals-handler'
          >
            <u>{translateWithI18Next(VIEW_DETAILS)}</u>
          </div>
        </div>
        {getPromosButton(item)}
      </div>
    </>
  );

  const getTextComponent = () => (
    <div className='promosCard-content'>
      <div className='promosOnlyTextCard-title'>
        <span className='promosCard-ellipsis-text'>{sanitizeContent(titleValue)}</span>
      </div>
      <div className='promosOnlyTextCard-text'>
        <span className='promosCard-ellipsis-text'>{sanitizeContent(smallText)}</span>
      </div>
      <div className='view-all-text'>
        <div
          onClick={event => setViewDetailsHandler(props)}
          className='offersViewAll-link'
          data-testid='view-all-deals-handler'
        >
          <u>{translateWithI18Next(VIEW_DETAILS)}</u>
        </div>
      </div>
      {getPromosButton(item)}
    </div>
  );

  const getEmptyCard = () => (
    <div className={`slick-slide medium-card-offers-deals`}>
      <div className='promosCard-content'>
        <div
          className={`promosOnlyTextCard-title small-text ${getAndCheck(page === PLP_PAGE, 'plp-empty-card-title')}`}
        >
          {translateWithI18Next(THATS_ALL_FOR_NOW)}
        </div>
        <div className='promosOnlyTextCard-text small-text emptycard'>{translateWithI18Next(CHECK_BACK_AGAIN)}</div>
      </div>
    </div>
  );

  const getLoginCard = () => (
    <>
      <ReactSVG src={SignInCard} className='offers-store-image' alt='' />
      <h3 className={`offer-login-text ${getAndCheck(page === PLP_PAGE, 'plp-offer-login-text')}`}>
        {translateWithI18Next(SIGNIN_TEXT)}
      </h3>
      <div className={`offer-store-btn-container ${getAndCheck(page === PLP_PAGE, 'plp-offer-store-btn-container')} `}>
        <ButtonComp
          data-testid='sign-in-btnid'
          onClick={() => createSignInURL()}
          className='store-btn signin-offers-btn'
        >
          {translateWithI18Next(GUEST_USER_SINGIN_TEXT)}
        </ButtonComp>
      </div>
    </>
  );

  const getPlpCardComponent = () => (
    <div className='plp-promosCard-content promosCard-content'>
      <div className='plp-promosOnlyTextCard-title promosOnlyTextCard-title'>
        <span className='promosCard-ellipsis-text'>{sanitizeContent(titleValue)}</span>
      </div>
      <div className='plp-promosOnlyTextCard-text promosOnlyTextCard-text'>
        <span className='promosCard-ellipsis-text'>{sanitizeContent(smallText)}</span>
      </div>
      <div className='plp-view-all-text view-all-text'>
        <div
          onClick={event => setViewDetailsHandler(props)}
          className='plp-offersViewAll-link offersViewAll-link'
          data-testid='plp-view-all-deals-handler'
        >
          <u>{translateWithI18Next(VIEW_DETAILS)}</u>
        </div>
      </div>
      {getPromosButton(item)}
    </div>
  );

  const renderCardTypeContainer = () => {
    if (promosRewardsImage && page === PLP_PAGE) {
      switch (item?.cardType) {
        case 'empty':
          return getEmptyCard();
        case 'login':
          return getLoginCard();
        default:
          return getPlpCardComponent();
      }
    }
    switch (item?.cardType) {
      case 'image-text':
        return getImageTextComponent();
      case 'image':
        return getImageComponent();
      case 'text':
        return getTextComponent();
      case 'empty':
        return getEmptyCard();
      case 'login':
        return getLoginCard();
    }
  };

  return <React.Fragment>{renderCardTypeContainer()}</React.Fragment>;
};

export default PromosRewardsCard;
